import Vue from 'vue'
import VueRouter from 'vue-router'

const Main = () => import('@/views/main/index')
const Home = () => import('@/views/home/index')
const Shop = () => import('@/views/shop/index')
const PersonWarehouse = () => import('@/views/shop/personWarehouse/index')    // 个人仓库
const BlindBox = () => import('@/views/shop/blindBox/index')                  // 盲盒

// 1.安装插件
Vue.use(VueRouter)

// 2.创建router
const routes = [
  {
    path: '/',
    redirect: '/shop',
    meta: {
      title:'宠物森林'
    },
    component: Main,
  },
  {
    path: '/main',//主页
    name: 'Main',
    component:Main,
    children:[
      {
        path:'/home',       // 首页
        name:'home',
        component:Home,
        meta: {
          title:"宠物森林 - 首页"
        }
      },
      {
        path:'/shop',       // 商城
        name:'shop',
        component:Shop,
        meta: {
          title:"宠物森林 - 商城"
        }
      },
      {
        path:'/shop/personWarehouse', // 个人仓库
        name:'personWarehouse',
        component:PersonWarehouse,
        meta: {
          title:"宠物森林 - 个人仓库"
        }
      },
      {
        path:'/shop/blindBox',  // 盲盒
        name:'blindBox',
        component:BlindBox,
        meta: {
          title:"宠物森林 - 盲盒"
        }
      },
    ],
  }
]

const router = new VueRouter({
  routes,
  mode: 'hash'
})

export default router
